export const SCREEN_WIDTHS = {
  mobile: "576px",
  desktop: "1200px",
};
